import React, { forwardRef } from 'react';
import Proptypes from 'prop-types';
import MaterialFormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '../../lib/styles';

const useStyles = makeStyles(theme => ({
  root: {
    color: theme.palette.grey[800],
  },
}));

const FormControlLabel = forwardRef(function FormControlLabel(
  { className, value, control, label, ...restProps },
  ref
) {
  const classes = useStyles();

  return (
    <MaterialFormControlLabel
      className={className}
      classes={classes}
      ref={ref}
      value={value}
      control={control}
      label={label}
      {...restProps}
    />
  );
});

FormControlLabel.propTypes = {
  className: Proptypes.string,
  control: Proptypes.node.isRequired,
  label: Proptypes.node,
  value: Proptypes.string,
};

FormControlLabel.defaultProps = {
  className: '',
  label: '',
  value: '',
};

FormControlLabel.displayName = 'FormControlLabel';

export default FormControlLabel;
